import { render, staticRenderFns } from "./OvertimeRequestCommentListItem.vue?vue&type=template&id=a720bcde&"
import script from "./OvertimeRequestCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./OvertimeRequestCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports